/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateTeamBody
 */
export interface CreateTeamBody {
  /**
   *
   * @type {string}
   * @memberof CreateTeamBody
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateTeamBody
   */
  description?: string | null;
}

/**
 * Check if a given object implements the CreateTeamBody interface.
 */
export function instanceOfCreateTeamBody(
  value: object,
): value is CreateTeamBody {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function CreateTeamBodyFromJSON(json: any): CreateTeamBody {
  return CreateTeamBodyFromJSONTyped(json, false);
}

export function CreateTeamBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateTeamBody {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
  };
}

export function CreateTeamBodyToJSON(json: any): CreateTeamBody {
  return CreateTeamBodyToJSONTyped(json, false);
}

export function CreateTeamBodyToJSONTyped(
  value?: CreateTeamBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    description: value["description"],
  };
}
